import React, { useState } from 'react'
import Heading from 'components/Typography/Header'
import { Plus, Minus } from 'lucide-react'

const FAQItem = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className='mb-6'>
            <div className='group p-6 bg-gradient-to-br from-gray-900/80 to-gray-900/60 rounded-2xl border border-gray-700/50 backdrop-blur-sm hover:border-primary/30 transition-all duration-300'>
                <div className='flex justify-between items-start gap-4'>
                    <div className='flex-1'>
                        <div className='cursor-pointer' onClick={handleClick}>
                            <Heading level={4} className="text-white text-xl font-semibold group-hover:text-primary transition-colors duration-300">{question}</Heading>
                        </div>
                        <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 opacity-100 mt-6' : 'max-h-0 opacity-0'}`}>
                            <div className='border-t border-gray-700/50 pt-6'>
                                <div className='text-gray-200 leading-relaxed'>
                                    {answer}
                                </div>
                            </div>
                        </div>
                    </div>
                    <button 
                        onClick={handleClick}
                        className={`p-3 w-12 h-12 rounded-xl flex items-center justify-center transition-all duration-300 ${
                            isOpen 
                                ? 'bg-gradient-to-r from-primary to-secondary shadow-lg shadow-primary/25' 
                                : 'bg-gray-800 border border-gray-700/50 hover:border-primary/30'
                        }`}
                    >
                        {isOpen ? 
                            <Minus size={20} className="text-white" /> : 
                            <Plus size={20} className="text-gray-300" />
                        }
                    </button>
                </div>
            </div>
        </div>
    );
}

export default FAQItem